import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { Field } from 'redux-form/immutable';

// mui components
import Grid from '@material-ui/core/Grid';

// local components
import CheckboxInput from '../../../CheckboxInput';
import CategoryLabel from '../CategoryLabel';

class CategoriesFields extends React.PureComponent {
  static propTypes = {
    categories: PropTypes.instanceOf(Immutable.Iterable).isRequired,
  }

  render() {
    const {
      categories,
    } = this.props;

    return categories.map((category) => {
      const name = category.get('name', '');
      const id = category.get('_id', '');
      const roundType = category.get('roundType', '');
      const roundTypeName = category.get('roundTypeName', '');

      return (
        <Grid item
          key={ `${name} ${id}` }
          xs={ 12 }>
          <Field name={ `displayCategoryScoresList.${id}` }
            label={ (
              <CategoryLabel name={ name }
                roundType={ roundType }
                roundTypeName={ roundTypeName } />
            ) }
            size='small'
            component={ CheckboxInput } />
        </Grid>
      );
    });
  }
}

export default CategoriesFields;
